import React from "react"
import ReactDOM from "react-dom"

import domready from "domready"
import "./style.css"
import App from "./ui/App"
import { AppState } from "./state"


const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};


let appState
domready(
    () => {

        appState = new AppState()

        ReactDOM.render(
            <App appState={ appState }/>,
            document.getElementById("root"),
            () => console.log("ready")
        )
    }
);

export default {
    state: () => appState
}
